export default "__VITE_ASSET__BtRJD2Ay__"